import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import ClientFormComponent from '../components/form/client/Client';
import PunchoutUserIdentificationComponent from '../components/form/client/PunchoutUserIdentification';

class Parameters extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      clientForm: true,
      punchoutUserIdentificationForm: false,
    };
  }

  setPage = (page) => {
    if (page === 'clientForm') {
      this.setState({
        clientForm: true,
        punchoutUserIdentificationForm: false,
      });
    }

    if (page === 'punchoutUserIdentificationForm') {
      this.setState({
        clientForm: false,
        punchoutUserIdentificationForm: true,
      });
    }
  }

  renderPage = () => {
    const { clientForm } = this.state;
    const { back } = this.props;

    if (clientForm) return (<ClientFormComponent back={back} />);
    return (<PunchoutUserIdentificationComponent back={back} />);
  }

  render() {
    const { companyTag } = this.props;
    const { item } = this.props.back.location;
    const { clientForm, punchoutUserIdentificationForm } = this.state;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
            <h2 style={{ fontWeight: '900', marginBottom: '0px' }}>{I18n.t('clientRegister')}</h2>
            {(item && item.completeLogoUrl) && (
              <img
                src={item.completeLogoUrl}
                style={{
                  maxHeight: '60px',
                  height: '60px',
                  marginLeft: '10px',
                  border: '1px solid #fff',
                  borderRadius: '10px',
                  width: '100px',
                  maxWidth: '100px',
                }}
              />
            )}
          </div>
          {companyTag === 'nortel' && item && (
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist" style={{ background: 'white' }}>
                <button
                  type="button"
                  className={`nav-item nav-link ${clientForm ? 'active' : ''}`}
                  id="nav-new-users-tab"
                  data-toggle="tab"
                  href="#nav-new-users"
                  role="tab"
                  aria-controls="nav-new-users"
                  aria-selected="true"
                  onClick={() => this.setPage('clientForm')}
                >
                  {I18n.t('client')}
                </button>
                <button
                  type="button"
                  className={`nav-item nav-link ${punchoutUserIdentificationForm ? 'active' : ''}`}
                  id="nav-places-tab"
                  data-toggle="tab"
                  href="#nav-places"
                  role="tab"
                  aria-controls="nav-places"
                  aria-selected="true"
                  onClick={() => this.setPage('punchoutUserIdentificationForm')}
                >
                  {I18n.t('punchoutUserIdentification')}
                </button>
              </div>
            </nav>
          )}
          <div className={companyTag === 'nortel' ? "tab-content" : ''} id="nav-tabContent" style={item ? {} : {padding: '0px'}}>
            <div className="tab-pane fade show active margin-top-20" id="nav-new-users" role="tabpanel" aria-labelledby="nav-new-users-tab">
              {this.renderPage()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companyTag: state.settings.companyTag,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Parameters);
